interface FormsEmptyIconProps {
  className?: string;
}

function FormsEmptyIcon({ className }: FormsEmptyIconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 13.333H18.667C17.606 13.333 16.589 13.755 15.839 14.505C15.088 15.255 14.667 16.273 14.667 17.333V50.667C14.667 51.727 15.088 52.745 15.839 53.495C16.589 54.245 17.606 54.667 18.667 54.667H45.333C46.394 54.667 47.411 54.245 48.161 53.495C48.912 52.745 49.333 51.727 49.333 50.667V17.333C49.333 16.273 48.912 15.255 48.161 14.505C47.411 13.755 46.394 13.333 45.333 13.333H40M24 13.333C24 14.394 24.421 15.411 25.172 16.161C25.922 16.912 26.939 17.333 28 17.333H36C37.061 17.333 38.078 16.912 38.828 16.161C39.579 15.411 40 14.394 40 13.333M24 13.333C24 12.273 24.421 11.255 25.172 10.505C25.922 9.755 26.939 9.333 28 9.333H36C37.061 9.333 38.078 9.755 38.828 10.505C39.579 11.255 40 12.273 40 13.333M24 32H40M24 42.667H34.667"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default FormsEmptyIcon;
